import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { userActivityApi } from '@/api/userActivityApi'
import { useTenant } from '@/providers/TenantProvider'

/**
 * Records each page the signed-in person opens, for the User audit trail
 * (the client, 2026-09-29: "what pages he or she visited"). The path only —
 * never the query string. Once per page: a re-render or a query-string change
 * on the same page is not a visit.
 */
export function usePageViewLog(basePath = ''): void {
  const { pathname } = useLocation()
  const { isTenantResolved, selectedTenantId } = useTenant()
  const last = useRef<string | null>(null)
  useEffect(() => {
    // The server records a visit in the tenant being worked in, so wait for one.
    if (!isTenantResolved || !selectedTenantId) return
    const path = `${basePath}${pathname}`
    // "/" only redirects to the dashboard; it is not a page anyone opened.
    if (pathname === '/') return
    if (last.current === path) return
    last.current = path
    userActivityApi.pageView(path)
  }, [pathname, basePath, isTenantResolved, selectedTenantId])
}
